import Vue from "vue";
import axios from "axios";
import swal from "sweetalert";

// initial state
const state = {
  records: [],
  profile: {},

  formRecord: {},
  editMode: false,
  showForm: false,

  showSendNotificationForm: false,

  total_commads: 0,

  page: 1,
  totalPages: 0,
  filters: { page: 1 },
};
// getters
const getters = {
  adminInfo: (state) => state.profile,
}; 
// mutations
const mutations = {
  SET_TOTAL_COMMADS(state, total) {
    state.total_commads = total;
  },
  SET_FILTERS(state, filters) {
    for (const key in filters) {
      if (filters[key] == "") {
        filters[key] = undefined;
      }
    }
    state.filters = filters;
  },
  SET_RECORDS(state, records) {
    state.records = records;
  },
  MY_PROFILE(state, profile) {
    state.profile = profile;
  },
  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = Math.ceil(totalPages / 10);
  },

  SET_PAGE(state, page) {
    state.page = page;
  },
   
  SET_FORM_RECORD(state, formRecord) {
    state.formRecord = formRecord;
    // console.log("dataaaa" ,formRecord )
  },

  SET_EDIT_MODE(state, mode) {
    state.editMode = mode;
  },

  SHOW_FORM(state) {
    state.showForm = true;
  },

  HIDE_FORM(state) {
    state.showForm = false;
  },

  SHOW_SEND_NOTIFICATION_FORM(state) {
    state.showSendNotificationForm = true;
  },

  HIDE_SEND_NOTIFICATION_FORM(state) {
    state.showSendNotificationForm = false;
  },


  APPEND_RECORD(state, record) {
    state.records.push(JSON.parse(JSON.stringify(record)));
  },

  UPDATE_RECORD(state, record) {
    let recordIndex = state.records.findIndex((item) => {
      return item.id == record.id;
    });
    Vue.set(state.records, recordIndex, JSON.parse(JSON.stringify(record)));
  },

  DELETE_RECORD(state, recordId) {
    state.records.forEach((item, index) => {
      if (item.id == recordId) state.records.splice(index, 1);
    });
  },
  MULTI_DELETE_RECORD(state, recordIds) {
    recordIds.forEach((recordId) => {
      const index = state.records.findIndex((item) => item.id === recordId);
      if (index !== -1) {
        state.records.splice(index, 1);
      }
    });
  },

};

// actions
const actions = {
  fetchRecords({ state, commit }) {
    let url ="/admin/commercial-ads/list";
    // showAll==1 ?  url = "/admin/commercial-ads/list?active=1" : url = "/admin/commercial-ads/list"; 
    return axios
      .get(url, { params: {...state.filters} })
      .then((response) => {
        commit("SET_RECORDS", response.data.data);
        commit("SET_TOTAL_PAGES", response.data.total);
        commit("SET_TOTAL_COMMADS", response.data.total);
      });
  },
  fetchMyProfile({ state, commit }) {
    return axios
      .get("/dashboard/account/myprofile")
      .then((response) => {
        // console.log(response.data);
        commit("MY_PROFILE", response.data);
      });
  },

  // =========================================================================

  searchRecords({ commit }, query) {
    return axios.get("/admin/admins/list?q=" + query).then((response) => {
      commit("SET_RECORDS_SEARCH", response.data);
      commit("SET_TOTAL_PAGES", response.data.last_page);
    });
  },

  // =========================================================================

  create({ commit }, { form }) {
    let payload = new FormData();
    for (const property in form) {
      if(property == 'active') form.active==true? form.active=1:form.active=0
      if (form.hasOwnProperty(property) && form[property] != null)
        payload.append(property, form[property]);
    }

    return axios.post("/admin/commercial-ads/create", payload).then((response) => {
      commit("APPEND_RECORD", response.data);
     
    });
  },
  //==========================================================================
  
  // =========================================================================

  update({ dispatch }, { form }) {
    let payload = new FormData();
    for (const property in form) {
      if (form.hasOwnProperty(property) && form[property] != null)
        payload.append(property, form[property]);
    }
    return axios.post(`/admin/commercial-ads/update/${form.id}`, payload).then(() => {
      dispatch("fetchRecords", {});
    });
  },

  // =========================================================================
  block({ commit }, { record }) {
    var data = {
      id: record.id,
      is_active:0
    };
    return axios.put(`/admin/commercial-ads/change_status`, data);
  },

  unblock({ commit }, { record }) {
    var data = {
      id: record.id,
      is_active:1
    };
    return axios.put(`/admin/commercial-ads/change_status`, data);
  },


  // =========================================================================

  send_notification({ commit }, { form }) {
    let payload = new FormData();
    for (const property in form) {
      if (form.hasOwnProperty(property) && form[property] != null)
        payload.append(property, form[property]);
    }

    return axios.post("/admin/commercial-ads/send_notification", payload).then((response) => {
      commit("APPEND_RECORD", response.data);

    });
  },
  deleteCommercialAd({ commit }, id) {
    return axios.delete(`/admin/commercial-ads/${id}`).then((response) => {
      commit("DELETE_RECORD", id);
      swal("نجحت العملية", "تمت حذف الإعلان", "success");
      return response;
    });
  },

  multiDeleteRecords({ commit }, ids) {
    return axios.delete(`/admin/commercial-ads/multi/${ids}`).then((response) => {
      commit("MULTI_DELETE_RECORD", ids);
      swal("نجحت العملية", "تمت حذف السجلات المحددة بنجاح", "success");
      return response;
    });
  },


};

export default {
  namespaced: true,
  name: "commercialAds",
  state,
  getters,
  actions,
  mutations,
};
